import { useMemo } from 'react';

import type { AxiosRequestConfig } from 'axios';

import { useLangProvider } from '@/components/core/AppLayout';

import { useUser } from './useUser';

export default function useRequestConfigHeaders() {
  const { token } = useUser();
  const lang = useLangProvider();

  return useMemo(
    () =>
      ({
        Authorization: token,
        'Accept-Language': lang,
      }) satisfies AxiosRequestConfig['headers'],
    [lang, token]
  );
}
